import axios from 'axios'
import config from '@/config'
import { authState, clearAuth } from '@/store/auth'

export const service = axios.create({
  baseURL: config.api.baseURL,
  timeout: config.api.timeout,
  headers: { 'Content-Type': 'application/json;charset=utf-8' },
})

// 登录失效只清理身份并通知页面，不在请求层自动跳转微信授权。
function expireLogin() {
  clearAuth()
  authState.error = '登录已失效，请手动输入新的微信授权 code'
  window.dispatchEvent(new CustomEvent('auth:expired'))
}

service.interceptors.request.use((cfg) => {
  if (authState.token && cfg.withToken !== false) {
    cfg.headers.Authorization = 'Bearer ' + authState.token
  }
  return cfg
})

// 多数接口是 { code, msg, data }；RuoYi 分页接口是 { code, msg, rows, total }，没有 data 字段。
// 后者在请求配置里传 rawEnvelope，取完整信封，其余仍只把 data 交给页面。
service.interceptors.response.use(
  ({ data, config: requestConfig }) => {
    if (Number(data?.code) === 200) return requestConfig.rawEnvelope ? data : data.data
    if (Number(data?.code) === 401) expireLogin()
    throw new Error(data?.msg || '请求失败，请稍后重试')
  },
  (err) => {
    if (err.response?.status === 401) expireLogin()
    err.message = err.response?.data?.msg || (err.code === 'ECONNABORTED'
      ? '请求超时，请稍后重试'
      : '网络请求失败，请稍后重试')
    return Promise.reject(err)
  },
)

// 只保留当前接口及已有微信工具使用的 GET / POST。
export default {
  get(url, params, cfg = {}) {
    return service.get(url, { params, ...cfg })
  },
  post(url, data, cfg = {}) {
    return service.post(url, data, cfg)
  },
}
